/**
 * Autorización en el cliente.
 *
 * Es una ayuda de navegación, nunca la frontera real: el API vuelve a validar
 * cada permiso. Ocultar un botón no protege el endpoint que hay detrás.
 */
export const PERMISSIONS = {
  productsRead: 'products:read',
  productsWrite: 'products:write',
  inventoryWrite: 'inventory:write',
  reportsRead: 'reports:read',
  usersManage: 'users:manage',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export function hasPermission(
  permissions: readonly string[] | undefined,
  required: Permission,
): boolean {
  if (permissions === undefined) {
    return false;
  }
  return permissions.includes('*') || permissions.includes(required);
}

export function hasAnyPermission(
  permissions: readonly string[] | undefined,
  required: readonly Permission[],
): boolean {
  return required.some((permission) => hasPermission(permissions, permission));
}
